{
	"cardHeader": "Uzyskaj dostęp do swoich deklaracji",
	"supplierTitle": "Czy jesteś dostawcą deklaracji evoZero?",
	"supplierDescription": "Zarządzaj deklaracjami dla swoich materiałów evoZero.",
	"loginButton": "Zaloguj się"
}
